/**
 * NIGHTBOUND - boot / loading screen.
 *
 * Mirrors the plain-HTML boot message in index.html so there is never a flash
 * of unstyled content while the session and catalogue load.
 */

import { Logo } from './Logo'
import { Spinner } from './ui'

export function LoadingScreen({ message = 'Something is waiting' }: { message?: string }) {
  return (
    <div className="flex min-h-[100svh] flex-col items-center justify-center gap-8 px-6 text-center">
      <Logo size="lg" tagline="A dark creature-raising RPG" />
      <Spinner label="Opening the shelter" />
      <p className="max-w-xs text-sm leading-relaxed text-ash-400">{message}</p>
    </div>
  )
}

export function BootError({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="flex min-h-[100svh] flex-col items-center justify-center gap-6 px-6 text-center">
      <Logo size="md" />
      <p className="max-w-sm text-sm leading-relaxed text-blood-400">{message}</p>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="rounded-[3px] border border-ash-600 px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-bone-300 hover:bg-night-700"
        >
          Try again
        </button>
      ) : null}
    </div>
  )
}
